import { put, call, takeLatest, select } from "redux-saga/effects";
import * as Api from "./api";
import * as ActionConstants from "./actions/actionConstants";
import {SHOW_LOADER, HIDE_LOADER } from '../../../common/actionConstants';
import * as workkardDetailApi from "../../WorkkardDetail/api";
import * as stateActionConstants from "../../Header/actions/actionConstants";
import * as stateApi from "../../Header/api";
import { logout } from '../../WorkkardDetail/Saga/common';
import * as workkardDetailActionConstants from "../../../containers/WorkkardDetail/actions/actionConstants";
import {updatePanelDataPermissionSet} from '../../WorkkardDetail/Saga/middlePanelContainer';
import {  ErrorCode,MiddlePanelConstant,StringConstants } from '../../..//containers/WorkkardDetail/constants';
import { mapActivityDetailResponse } from '../../WorkkardDetail/slice';
import { normalizeActivityTimeZones } from '../../../common/util';

export function* fetchCreateActivityData(action) {
    try {
        yield put({ type: SHOW_LOADER });
        let response;
        if (action.payload.isEdit) {
            delete action.payload.isEdit;
            delete action.payload.isClone;
            response = yield call(Api.fetchEditActivityData, ActionConstants.FETCH_EDIT_ACTIVITY_DATA, action.payload);
        }
        else if(action.payload.isClone){
            delete action.payload.isEdit;
            delete action.payload.isClone; 
            response = yield call(Api.fetchCloneActivityData, ActionConstants.FETCH_CLONE_ACTIVITY_DATA, action.payload);
        }
        else {
            delete action.payload.isEdit;
            delete action.payload.isClone;
            response = yield call(Api.fetchCreateActivityData, ActionConstants.FETCH_CREATE_ACTIVITY_DATA, action.payload);
        }
        if (response.status == 200) {
            yield put({
                type: ActionConstants.FETCH_CREATE_ACTIVITY_DATA_SUCCESS,
                payload: response.model
            })
        }
    }
    catch (error) {
        console.log(error);
    }
    finally {
        yield put({ type: HIDE_LOADER });
    }
}


export function* createActivity(action) {
    try {
        yield put({ type:workkardDetailActionConstants.BUTTON_LOADER, payload: { createActivity: true}});
        const { callback }  = action.payload;
        delete action.payload.callback;
        const response = yield call(Api.createActivity, ActionConstants.CREATE_ACTIVITY_REQUEST, action.payload);
        if (response.status == 200) {
            const getWorkkardDetailData = (state) => state.workkardDetail.workkardDetail;
            const getItems = (state) => state.workkardDetail.activityListing;
            const workkardDetailData = yield select(getWorkkardDetailData);
            if (workkardDetailData.WorkkardStatus.toLowerCase() == 'close') {
               let reqPayload= { cId: response.Data.wkId, doNotUpdateActivityListing: true }
                const { workkard, status } = yield call(workkardDetailApi.getWorkkardDetailMasterData, reqPayload);
                if(status == 200){
                  if (workkard) {
                    yield put({ type: workkardDetailActionConstants.WORKKARD_DETAIL_MASTER_DATA_SUCCESS, payload: workkard });
                  }
              }
            }
            const items = yield select(getItems);
            const listingObj = {
                skip: 0,
                take: items.skip + items.take,
                cId: response.Data.wkId
            }
            const { activityData,status } = yield call(workkardDetailApi.getActivityListByClaim, listingObj)
            if(status == 200){
              if ( activityData.Activities && activityData.Activities.length) {  
                const tzData = yield select((state) => state.sessionContextOidc?.tzData);
                yield put({
                  type: workkardDetailActionConstants.UPDATE_ACTIVITY_LISTING_SUCCESS,
                  payload: {
                    skip: items.skip || 0,
                    take: items.take,
                    ...activityData,
                    Activities: normalizeActivityTimeZones(activityData.Activities, tzData)
                  }
                });
              }
            }
            callback(response.Data);   
        }
        else if(response.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type:workkardDetailActionConstants.LOG_APPLICATON_ERROR,
            payload: { status:response.status, isErrorScreen:false }
            });
        }
    }
    catch (error) {
        console.log(error);
    }
    finally {
        yield put({ type:workkardDetailActionConstants.BUTTON_LOADER, payload: { createActivity: false}});
    }
}

export function* updateActivity(action) {
    try {
        const { callback }  = action.payload;
        delete action.payload.callback;
        yield put({ type:workkardDetailActionConstants.BUTTON_LOADER, payload: { createActivity: true}});
        const response = yield call(Api.updateActivity, ActionConstants.UPDATE_ACTIVITY_REQUEST, action.payload);
        if (response.status == 200) {
            const getItems = (state) => state.workkardDetail;
            const items = yield select(getItems);
            if(items.middlePanel.activeTab == 1 && (items.middlePanel.files.type == "All" || items.middlePanel.files.type == "activity")){
                const paramFiles={
                   type: items.middlePanel.files.type,
                   cId: items.middlePanel.files.type == StringConstants.activity ? '' : items.workkardDetail.Id,
                   actId: items.middlePanel.files.type == StringConstants.activity ? items.activityDetail.activityId : '',
                   skip: items.middlePanel.files.skip,
                   take: items.middlePanel.files.take,
                   sortBy: "1",
                   largeView: false,
                   isSelectAll: false,
                   filterOption: (items.middlePanel.files.type == "All") ? JSON.stringify(["Document", "Photo", "Audio", "Video", "Email", "Other", MiddlePanelConstant.WorkkardType, MiddlePanelConstant.ActivityType]) : JSON.stringify(["Document", "Photo", "Audio", "Video", "Email", "Other", items.middlePanel.files.type])
                };
                yield* updatePanelDataPermissionSet({ payload: paramFiles , permission:{isUpdateFiles:true}})
            }
            if(items.middlePanel.activeTab==3 && (items.middlePanel.logs.type == "activity")){
                const paramLogs = {
                    type:  items.middlePanel.logs.type ,
                    cId:    items.workkardDetail.Id,
                    actId:  items.activityDetail.activityId,
                    skip:   0,
                    take:   10,
                    sortBy: "0"
                };
                yield* updatePanelDataPermissionSet({ payload: paramLogs , permission:{isUpdateLogs:true}})
            }
            const { activityDetail, status } = yield call(workkardDetailApi.getActivityDetail, response.Data.Id)
            if(status == 200){
              if (activityDetail) {
                yield put({ type: workkardDetailActionConstants.ACTIVITY_DETAIL_DATA_SUCCESS, payload: mapActivityDetailResponse(activityDetail) });
              }
            }
            const listingObj = {
                skip: 0,
                take: items.activityListing.skip + items.activityListing.take,
                cId: items.workkardDetail.Id
            }
            const listingResponse = yield call(workkardDetailApi.getActivityListByClaim, listingObj)
            if(listingResponse.status == 200){
              if (listingResponse.activityData.Activities &&  listingResponse.activityData.Activities.length) {  
                const tzData = yield select((state) => state.sessionContextOidc?.tzData);
                yield put({
                  type: workkardDetailActionConstants.UPDATE_ACTIVITY_LISTING_SUCCESS,
                  payload: {
                    skip: items.skip || 0,
                    take: items.take,
                    ...listingResponse.activityData,
                    Activities: normalizeActivityTimeZones(listingResponse.activityData.Activities, tzData)
                  }
                });
              }
            }
            callback({}); 
        }
        else if(response.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: workkardDetailActionConstants.LOG_APPLICATON_ERROR,
            payload: { status:response.status, isErrorScreen:false }
            });
        }
    }
    catch (error) {
        console.log(error);
    }
    finally {
        yield put({ type:workkardDetailActionConstants.BUTTON_LOADER, payload: { createActivity: false}});
    }
}

export function* fetchSkillsetTags(action) {
    try {
        const response = yield call(Api.fetchSkillsetTags, ActionConstants.FETCH_SKILLSET_TAGS);
        if (response.status == 200) {
            yield put({
                type: ActionConstants.FETCH_SKILLSET_TAGS_SUCCESS,
                payload: {
                    tags: response.Data.map(tag => ({
                        id: tag,
                        text: tag,
                    }))
                }
            })
        }
    }
    catch (error) {
        console.log(error);
    }
}

export function* fetchAssignmentMethodTeamMemberList(action) {
    try {
        const response = yield call(Api.fetchAssignmentMethodTeamMemberList, ActionConstants.FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST);
        if (response.status == 200) {
            yield put({
                type: ActionConstants.FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST_SUCCESS,
                payload: response.tmList
            })
        }
    }
    catch (error) {
        console.log(error);
    }
}

export function* fetchAssignmentMethodB2BList(action) {
    try {
        const response = yield call(Api.fetchAssignmentMethodB2BList, ActionConstants.FETCH_ASSIGNMENTMETHOD_B2BLIST);
        if (response.status == 200) {
            yield put({
                type: ActionConstants.FETCH_ASSIGNMENTMETHOD_B2BLIST_SUCCESS,
                payload:response.b2bList
            })
        }
    }
    catch (error) {
        console.log(error);
    }
}

export function* fetchAssignmentMethodContractList(action) {
    try {
        const response = yield call(Api.fetchAssignmentMethodContractList, ActionConstants.FETCH_ASSIGNMENTMETHOD_CONTRACTLIST, action.payload);
        if (response.status == 200) {
            yield put({
                type: ActionConstants.FETCH_ASSIGNMENTMETHOD_CONTRACTLIST_SUCCESS,
                payload: response.b2bOrgs
            })
        }
    }
    catch (error) {
        console.log(error);
    }
}


export function* fetchStatesData(action) {
    try {
        const response = yield call(stateApi.fetchPartyStates, stateActionConstants.FETCH_PARTY_STATES_REQUEST, action.payload);
        if (response.status == 200) {
            yield put({
                type: ActionConstants.FETCH_PROPERTY_STATES_SUCCESS,
                payload: response.Data
            })
        }
    }
    catch (error) {
        console.log(error);
    }
}

export function* getLocationByZip(action) {
    try {
        const { suggestion, status } = yield call(Api.getLocationByZip, ActionConstants.FETCH_PROPERTY_LOCATION, action.payload);
        if (status == 200) {
            yield put({
                type: ActionConstants.FETCH_PROPERTY_LOCATION_SUCCESS,
                payload: suggestion
            })
        }
    }
    catch (error) {
        console.log(error);
    }
}


export default [
    takeLatest(ActionConstants.FETCH_CREATE_ACTIVITY_DATA, fetchCreateActivityData),
    takeLatest(ActionConstants.FETCH_SKILLSET_TAGS, fetchSkillsetTags),
    takeLatest(ActionConstants.FETCH_PROPERTY_LOCATION, getLocationByZip),
    takeLatest(ActionConstants.CREATE_ACTIVITY_REQUEST, createActivity),
    takeLatest(ActionConstants.UPDATE_ACTIVITY_REQUEST, updateActivity),
    takeLatest(ActionConstants.FETCH_PROPERTY_STATES_REQUEST, fetchStatesData),
    takeLatest(ActionConstants.FETCH_ASSIGNMENTMETHOD_TEAMMEMBERLIST, fetchAssignmentMethodTeamMemberList), 
    takeLatest(ActionConstants.FETCH_ASSIGNMENTMETHOD_B2BLIST, fetchAssignmentMethodB2BList), 
    takeLatest(ActionConstants.FETCH_ASSIGNMENTMETHOD_CONTRACTLIST, fetchAssignmentMethodContractList) 
];